import React from "react";
import LegalPage, { LegalSection } from "../components/LegalPage";

export default function RefundPolicyPage() {
  return (
    <LegalPage
      title="청약철회 및 환불 정책"
      description="서버 카드 디지털 상품의 취소, 환불 및 분쟁 처리 기준입니다."
      effectiveDate="2026년 8월 3일"
    >
      <LegalSection title="1. 공급 방식">
        <p>결제가 완료되면 구매한 서버 카드가 구매자가 선택한 서버에 즉시 적용되며 디지털 콘텐츠의 공급이 시작됩니다. 결제 전에 상품 미리보기, 가격, 판매자, 적용 서버와 환불 제한 사항을 확인할 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="2. 미사용 상품의 청약철회">
        <p>상품이 서버에 적용되지 않은 미사용 상태라면 결제일부터 7일 이내에 청약철회를 요청할 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="3. 즉시 공급된 디지털 상품">
        <p>구매자가 상품 미리보기를 확인하고 즉시 공급에 명시적으로 동의한 뒤 상품이 서버에 적용된 경우에는 단순 변심에 따른 청약철회가 제한될 수 있습니다. 다만 관계 법령이 보장하는 하자·불일치 환불 권리는 제한되지 않습니다.</p>
      </LegalSection>
      <LegalSection title="4. 상품 하자 또는 표시 내용과의 불일치">
        <p>상품이 표시·광고 내용과 다르거나 계약 내용대로 작동하지 않으면 공급일부터 3개월 이내 또는 그 사실을 안 날부터 30일 이내에 환불을 요청할 수 있습니다. 회사 또는 판매자의 책임이 확인되면 전액 환불하거나 정상 상품으로 교환합니다.</p>
      </LegalSection>
      <LegalSection title="5. 요청 및 처리 기간">
        <p>상점의 구매 내역에서 주문별 환불 사유를 입력해 요청할 수 있습니다. 회사는 접수 진행 상황을 3영업일 이내에 안내하고, 원칙적으로 10영업일 이내에 처리 결과 또는 처리 계획을 알립니다.</p>
        <p>환불이 확정되면 3영업일 이내에 결제대금 환급 또는 카드 결제 취소를 요청합니다. 실제 반영 시점은 카드사와 결제수단에 따라 달라질 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="6. 문의">
        <p>환불 및 거래 분쟁 문의: inhyuk0078@gmail.com · 010-9174-6988</p>
      </LegalSection>
    </LegalPage>
  );
}
